import { render, staticRenderFns } from "./flatIconButton.vue?vue&type=template&id=53f60d3e&scoped=true"
import script from "./flatIconButton.vue?vue&type=script&lang=js"
export * from "./flatIconButton.vue?vue&type=script&lang=js"
import style0 from "./flatIconButton.vue?vue&type=style&index=0&id=53f60d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f60d3e",
  null
  
)

export default component.exports